import { render, staticRenderFns } from "./BlocoBlog.vue?vue&type=template&id=39897629&scoped=true"
import script from "./BlocoBlog.vue?vue&type=script&lang=js"
export * from "./BlocoBlog.vue?vue&type=script&lang=js"
import style0 from "./BlocoBlog.vue?vue&type=style&index=0&id=39897629&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39897629",
  null
  
)

export default component.exports